const SendIcon = () => (
  <path d="M19.6686 11.9085L4.81179 5.05152C4.57523 4.94409 4.29295 5.00809 4.12838 5.21152C3.96267 5.41494 3.95696 5.70408 4.11467 5.91321L9.00026 12.4273L4.11467 18.9415C3.95696 19.1506 3.96267 19.4409 4.12724 19.6432C4.23809 19.7814 4.4038 19.8557 4.5718 19.8557C4.65294 19.8557 4.73408 19.8386 4.81065 19.8032L19.6674 12.9462C19.8709 12.8525 20 12.6502 20 12.4273C20 12.2045 19.8709 12.0022 19.6686 11.9085Z" />
);

export default SendIcon;
